import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { MathLib } from '@morpho-org/blue-sdk';
import { Donut, getDonutColor } from '@morpho-org/ui-v6/server';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { memo, useMemo } from 'react';
import { formatUnits } from 'viem';
import { getShareFromTotal } from '@/helpers/vault';
import VaultV2CapDonutSpacer, { CAP_DONUT_RADIUS } from './VaultV2CapDonutSpacer';
interface VaultV2AbsoluteCapCellProps {
  absoluteCap: bigint;
  allocation: bigint;
  token: InterfaceToken | null | undefined;
  index: number;
}
function VaultV2AbsoluteCapCell(t0) {
  const $ = _c(23);
  const {
    absoluteCap,
    allocation,
    token,
    index
  } = t0;
  const isInfinite = absoluteCap >= MathLib.RAY;
  let t1;
  bb0: {
    if (isInfinite) {
      t1 = "Infinite";
      break bb0;
    }
    let t2;
    if ($[0] !== absoluteCap || $[1] !== token?.decimals) {
      t2 = formatters.short.default("0").trailingZero(false).digits(2).of(absoluteCap, token?.decimals);
      $[0] = absoluteCap;
      $[1] = token?.decimals;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const formattedAbsoluteCap = t1;
  let t2;
  if ($[3] !== absoluteCap || $[4] !== allocation) {
    t2 = getShareFromTotal(absoluteCap, allocation);
    $[3] = absoluteCap;
    $[4] = allocation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const percentShare = t2;
  let t3;
  if ($[6] !== percentShare) {
    t3 = formatUnits(percentShare, 18);
    $[6] = percentShare;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const percentShareNumber = Number(t3) * 100;
  let t4;
  bb1: {
    if (percentShareNumber >= 100) {
      t4 = "var(--color-warning-foreground)";
      break bb1;
    }
    let t5;
    if ($[8] !== index) {
      t5 = getDonutColor(index);
      $[8] = index;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = t5;
  }
  const donutColor = t4;
  let t5;
  if ($[10] !== percentShare) {
    t5 = formatters.percent.default("0").digits(2).unit("%").of(percentShare, 18);
    $[10] = percentShare;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const formattedPercentFilled = t5;
  let t6;
  if ($[12] !== donutColor || $[13] !== formattedPercentFilled || $[14] !== isInfinite || $[15] !== percentShareNumber) {
    t6 = isInfinite ? <VaultV2CapDonutSpacer /> : <Tooltip><TooltipTrigger asChild={true}><div className="flex cursor-default"><Donut allocation={percentShareNumber} color={donutColor} backgroundColor="var(--color-muted)" radius={CAP_DONUT_RADIUS} /></div></TooltipTrigger><TooltipContent>{`${formattedPercentFilled} filled`}</TooltipContent></Tooltip>;
    $[12] = donutColor;
    $[13] = formattedPercentFilled;
    $[14] = isInfinite;
    $[15] = percentShareNumber;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      lineHeight: "normal"
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== formattedAbsoluteCap) {
    t8 = <span className="text-2xs text-foreground" style={t7}>{formattedAbsoluteCap}</span>;
    $[18] = formattedAbsoluteCap;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <div className="gap-xs flex items-center">{t6}{t8}</div>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
export default memo(VaultV2AbsoluteCapCell);